import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import "bootstrap/dist/css/bootstrap.min.css"



import '@/assets/Icons/icons.css'
import i18n from './Lang/lang'
import 'vue-loading-overlay/dist/css/index.css'
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css"; //icons 

import PrimeVue from "primevue/config";
//import  defaultOptions   from 'primevue/config';
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Button from "primevue/button";
import HeaderMenu from "@/assets/Theme/ModernTheme/JS/headerHelper.js"


import axios from 'axios';
import setupInterceptors from '@/Services/setupInterceptors.js';
import FilterUtility from '@/helpers/filters.js'
import HelpersUtility from '@/helpers/helpers.js'
import configuration from '@/helpers/configuration.js'
import Swiper from './assets/vendor/swiper/SwiperMain'

import script from './assets/js/main.js'


////GolfCart JS
///*import jquery371 from "@/assets/Theme/GolfCart/js/jquery-3.7.1.min.js"*/
//import bootstrap from './assets/vendor/bootstrap/js/bootstrap.bundle.min.js'
////import bootstrapbundle from "@/assets/Theme/GolfCart/JS/bootstrap.bundle.min.js"
//import jquerywaypoints from "@/assets/Theme/GolfCart/js/jquery.waypoints.js"
//import jquerycounterup from "@/assets/Theme/GolfCart/js/jquery.counterup.min.js"
//import select2min from "@/assets/Theme/GolfCart/plugins/select2/js/select2.min.js"
//import aosJs from "@/assets/Theme/GolfCart/plugins/aos/aos.js"
//import backToTopJs from "@/assets/Theme/GolfCart/js/backToTop.js"

//import momentMinJs from "@/assets/Theme/GolfCart/plugins/moment/moment.min.js"
//import bootstrapMIn from "@/assets/Theme/GolfCart/js/bootstrap-datetimepicker.min.js"
////import owlcarousel from "@/assets/Theme/GolfCart/js/owl.carousel.min.js"
//import scriptJs from "@/assets/Theme/GolfCart/js/script.js"
////End Gold cart js

import { LoadingPlugin } from 'vue-loading-overlay';
import router from './router'
import * as ConfirmDialog from "vuejs-confirm-dialog";
import Loading from '@/views/shared/loader.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import { vMaska } from "maska"
import VueHtmlToPaper from "./views/shared/VueHtmlToPaper";
import CKEditor from '@mayasabha/ckeditor4-vue3';
import Dropdown from "primevue/dropdown";
import GoogleMap from "@/views/shared/google-map/GoogleMap.vue"
import VueLazyLoad from 'vue3-lazyload'
import Popper from "vue3-popper";

const app = createApp(App)
const pinia = createPinia()

app.use(router).use(LoadingPlugin)
app.use(setupInterceptors)
app.use(ConfirmDialog)
app.use("Popper", Popper)
app.use(i18n)
app.use(PrimeVue);
app.use(ToastService);
app.use(VueHtmlToPaper);
app.use(pinia)
app.component("Toast", Toast);
app.component("Button", Button);
app.component('Loading', Loading);
app.component('DataTable', DataTable);
app.component('Paginator', Paginator);
app.component('Column', Column);
app.component('Dropdown', Dropdown)
app.directive('maska', vMaska)
app.component('GoogleMap', GoogleMap);
app.use(VueLazyLoad, {
    // options...
})

//Global Properties 
app.config.globalProperties.$filters = FilterUtility;
app.config.globalProperties.$helpers = HelpersUtility;
app.config.globalProperties.$custConfig = configuration;
window.$ = window.jQuery = require('jquery');

//Services
app.provide('axios', axios)

//Add Mixin
app.mixin("", script);
app.mixin("", Swiper);
app.mixin("", HeaderMenu);
//app.mixin("", jquery371);



//app.mixin("", jquerywaypoints);
//app.mixin("", jquerycounterup);
//app.mixin("", select2min);

//app.mixin("", aosJs);
//app.mixin("", backToTopJs);
//app.mixin("", momentMinJs);
//app.mixin("", bootstrapMIn);
//app.mixin("", scriptJs);


app.mixin("", bootstrap);
app.mixin({
    methods: {
        success: function (msg) {
            this.$toast.add({ severity: 'success', summary: "Success Message", detail: msg, life: 3000 });
        },
        error: function (msg) {
            this.$toast.add({
                severity: 'error', summary: "Error Message", detail: msg, life: 3000
            });
        },
        warn: function (msg) {
            this.$toast.add({
                severity: 'warn', summary: "Warning Message", detail: msg, life: 3000
            });
        },
        ValidityState: function (msg) {
            this.$toast.add({
                severity: 'info', summary: "", detail: msg, life: 3000, styleClass: 'custom-info-toast'
            });
        }
    },
})

app.use(CKEditor);
app.use(function (req, res, next) {
    const isProduction = process.env.VUE_APP_PRODUCTION;
    localStorage.removeItem("domain");
    if (isProduction.toLocaleLowerCase() == "true") {
        if (location.protocol === 'http:') {
            window.location.href = location.href.replace('http', 'https');
        }
    }
});
app.mount('#app')
